import type { ValidateCouponResponse } from "@/models/coupon";
import { API_BASE, type APIResponse, callApi } from "@/services/api";

export async function validateCoupon(
  couponCodes: string | string[],
): Promise<APIResponse<ValidateCouponResponse>> {
  try {
    const codes = Array.from(
      new Set(
        (Array.isArray(couponCodes) ? couponCodes : [couponCodes]).filter(
          // Drop empty codes and unsubstituted placeholders (e.g. the literal
          // "{coupon_code}" the backend can return in specialPromo). A real
          // coupon code never contains braces; sending one only yields a
          // failed validation and trips API rate limiting.
          (code) => Boolean(code) && !/[{}]/.test(code),
        ) as string[],
      ),
    );

    if (!codes.length) {
      return {
        data: { valid: null, coupon: null, coupons: [] },
      } as unknown as APIResponse<ValidateCouponResponse>;
    }
    const params = new URLSearchParams();

    codes.forEach((code) => params.append("coupon_codes[]", code));

    const query = params.toString();
    const resp = await callApi<ValidateCouponResponse>(
      `${API_BASE}/coupons/validate${query ? `?${query}` : ""}`,
    );
    return resp;
  } catch (e) {
    throw e;
  }
}
